// Get the schedule id from a compare route's destination param ("draft!abc" -> "abc")
export function getCompareDestinationId(destination) {
    const [, id] = destination?.split("!") ?? []
    return id
}
